import { render, staticRenderFns } from "./InboxSelection.vue?vue&type=template&id=4d7412fb&scoped=true"
import script from "./InboxSelection.vue?vue&type=script&lang=ts"
export * from "./InboxSelection.vue?vue&type=script&lang=ts"
import style0 from "./InboxSelection.vue?vue&type=style&index=0&id=4d7412fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7412fb",
  null
  
)

export default component.exports